import styled from "@emotion/styled";

import { theme } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const UnitAdderRoot = styled.a(props => ({
    display: "block",
    border: theme(props).border.dashed,
    boxSizing: "border-box",
    maxWidth: 1000,
    margin: 0,
    padding: theme(props).size(2.5),
    textAlign: "center",
    color: theme(props).cardActualInfo.linkColor,
    fontSize: theme(props).typography.primary.fontSize.css(),
    lineHeight: theme(props).typography.primary.lineHeight.css(),
    textDecoration: "none",
    cursor: "pointer",

    ":hover": {
        backgroundColor: theme(props).keyPalette.panel2BackgroundColor,
    },
}));

export const UnitAdderDisabled = styled.a(props => ({
    display: "block",
    border: theme(props).border.dashed,
    boxSizing: "border-box",
    maxWidth: 1000,
    margin: 0,
    padding: theme(props).size(2.5),
    textAlign: "center",
    color: theme(props).typography.inactive.color,
    fontSize: theme(props).typography.primary.fontSize.css(),
    lineHeight: theme(props).typography.primary.lineHeight.css(),
    textDecoration: "none",
    cursor: "default",
}));
